import React from "react";
import {
  Box,
  Button,
  Container,
  Divider,
  Link,
  Paper,
  Typography,
  useTheme,
} from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import {
  PRIVACY_POLICY_EFFECTIVE_DATE,
  PRIVACY_POLICY_SECTIONS,
  renderPolicyBlock,
} from "./content";

const PrivacyPolicy = (): JSX.Element => {
  const theme = useTheme();
  const navigate = useNavigate();

  return (
    <Box minHeight="100vh" bgcolor={theme.palette.grey[100]}>
      <Container maxWidth="md" sx={{ py: 3 }}>
        <Button
          startIcon={<ArrowBack />}
          onClick={() => navigate(-1)}
          sx={{ mb: 2 }}
        >
          Back
        </Button>

        <Paper elevation={1} sx={{ p: { xs: 3, md: 4 }, borderRadius: 2 }}>
          <Typography
            variant="h4"
            component="h1"
            sx={{ fontWeight: 700, mb: 1, color: "#00395A" }}
          >
            Privacy Policy
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            Effective date: {PRIVACY_POLICY_EFFECTIVE_DATE}
          </Typography>

          <Typography variant="body1" paragraph sx={{ lineHeight: 1.75 }}>
            At Easy Agility, we are committed to protecting your personal data
            and your right to privacy. This Privacy Policy explains how we
            collect, use, store, and share your information when you use Easy
            Agility Hub, in accordance with the UK General Data Protection
            Regulation (UK GDPR) and the Data Protection Act 2018.
          </Typography>

          <Divider sx={{ my: 3 }} />

          {PRIVACY_POLICY_SECTIONS.map((section, sectionIndex) => (
            <Box key={section.title} component="section" sx={{ mb: 4 }}>
              <Typography
                variant="h6"
                component="h2"
                sx={{ fontWeight: 700, mb: 2, color: "#00395A" }}
              >
                {section.title}
              </Typography>
              {section.blocks.map((block, blockIndex) =>
                renderPolicyBlock(block, sectionIndex * 100 + blockIndex),
              )}
            </Box>
          ))}

          <Divider sx={{ my: 3 }} />

          <Typography variant="body2" color="text.secondary">
            Questions about this policy? Contact{" "}
            <Link href="mailto:matt@easyagility.co.uk" underline="hover">
              matt@easyagility.co.uk
            </Link>
            .
          </Typography>
        </Paper>
      </Container>
    </Box>
  );
};

export default PrivacyPolicy;
